<template>
  <div>
    <div v-if="showImage" class="overlay">
      <div
        style="
          position: absolute;
          right: 40px;
          top: 40px;
          z-index: 2001;
          display: flex;
          flex-direction: column;
        "
      >
        <div
          :title="$t('vierPicture.close')"
          class="view-close el-icon-circle-close"
          @click.self="showImage = false"
        ></div>
        <div
          v-show="isExport"
          :title="$t('vierPicture.export')"
          style="margin-top: 10px"
          class="view-close el-icon-sold-out"
          @click.self="handleExport"
        ></div>
      </div>
      <div
        ref="imageContainer"
        class="image-container"
        @mousedown="startDrag"
        @mousemove="dragImage"
        @mouseup="stopDrag"
        @mouseleave="stopDrag"
        @wheel="zoomImage"
      >
        <img
          ref="fullImage"
          :src="imageUrl"
          alt="Full Size"
          class="full-image"
          :style="imageStyle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getTableExport } from "@/api/chatbot";
import XLSX from "xlsx";

export default {
  data() {
    return {
      isExport: false,
      showImage: false,
      imageUrl: null,
      dragging: false,
      startX: 0,
      startY: 0,
      initialLeft: 0,
      initialTop: 0,
      zoom: 1,
      imageStyle: {
        transform: "scale(1)",
        left: "0px",
        top: "0px",
      },
    };
  },
  methods: {
    async handleHtmlToExport(html) {
      // 创建一个空的工作簿对象
      const wb = XLSX.utils.book_new();
      const tempElem = document.createElement("div");
      tempElem.innerHTML = html.trim();
      // 获取表格元素
      const tableToExcels = tempElem.querySelectorAll("table");
      if (!tableToExcels || tableToExcels.length <= 0) {
        this.$message.error("暂无表格数据导出");
      }
      tableToExcels.forEach((value, tableIndex) => {
        // 使用XLSX库将表格转换为工作簿对象的一个sheet
        const ws = XLSX.utils.table_to_sheet(value, { sheet: `Sheet ${tableIndex + 1}` });
        // 将该sheet添加到工作簿中
        XLSX.utils.book_append_sheet(wb, ws, `Sheet ${tableIndex + 1}`);
      });
      tempElem.remove();
      // 将工作簿对象写入到一个数组中
      const wopts = {
        bookType: "xlsx", // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: "binary",
      };
      const wbout = XLSX.write(wb, wopts);
      // 创建Blob对象，并保存为文件
      const blob = new Blob([this.s2ab(wbout)], { type: "application/octet-stream" });
      this.openDownloadDialog(blob, "bom信息.xlsx");
    },
    async handleExport(val) {
      if (val) {
        this.imageUrl = val;
      }
      const lastOf = this.imageUrl.lastIndexOf("/");
      const str = this.imageUrl.substr(lastOf + 1);
      const fileName = str.substring(0, str.lastIndexOf(".")).split("_");
      const params = Object.assign({
        file_id: parseInt(fileName[0]),
        page_num: parseInt(fileName[1]),
      });
      const tableExportData = await getTableExport(params);
      if (tableExportData && tableExportData.retcode === 200) {
        if (tableExportData.data.length > 0) {
          // 创建一个空的工作簿对象
          const wb = XLSX.utils.book_new();
          tableExportData.data.forEach((item, index) => {
            // 创建一个新的DOM元素，用于暂存HTML内容
            const tempElem = document.createElement("div");
            tempElem.innerHTML = item.segment_content.trim();
            // 获取表格元素
            // 获取表格元素
            const tableToExcels = tempElem.querySelectorAll("table");
            tableToExcels.forEach((value, tableIndex) => {
              // 使用XLSX库将表格转换为工作簿对象的一个sheet
              const ws = XLSX.utils.table_to_sheet(value, {
                sheet: `Sheet ${index + 1}-${tableIndex + 1}`,
              });
              // 将该sheet添加到工作簿中
              XLSX.utils.book_append_sheet(wb, ws, `Sheet ${index + 1}-${tableIndex + 1}`);
            });
            tempElem.remove();
          });
          // 将工作簿对象写入到一个数组中
          const wopts = {
            bookType: "xlsx", // 要生成的文件类型
            bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
            type: "binary",
          };
          const wbout = XLSX.write(wb, wopts);
          // 创建Blob对象，并保存为文件
          const blob = new Blob([this.s2ab(wbout)], { type: "application/octet-stream" });
          this.openDownloadDialog(blob, "新建文件.xlsx");
        } else {
          this.$message.error("暂无表格数据导出");
        }
      } else {
        this.$message.error("表格导出异常，请稍后重试！");
      }
    },
    openDownloadDialog(url, saveName) {
      if (typeof url === "object" && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
      }
      var aLink = document.createElement("a");
      aLink.href = url;
      aLink.download = saveName || ""; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      var event;
      if (window.MouseEvent) event = new MouseEvent("click");
      else {
        event = document.createEvent("MouseEvents");
        event.initMouseEvent(
          "click",
          true,
          false,
          window,
          0,
          0,
          0,
          0,
          0,
          false,
          false,
          false,
          false,
          0,
          null
        );
      }
      aLink.dispatchEvent(event);
    },
    // 字符串转ArrayBuffer
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    openView(scale, imgUrl, isExport) {
      this.isExport = isExport;
      this.imageUrl = imgUrl;
      this.zoom = scale;
      this.imageStyle = {
        transform: `scale(${this.zoom})`,
        left: "0px",
        top: "0px",
      };
      this.showImage = true;
    },
    startDrag(event) {
      event.preventDefault();
      this.dragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      const image = this.$refs.fullImage;
      this.initialLeft = parseFloat(image.style.left || 0);
      this.initialTop = parseFloat(image.style.top || 0);
    },
    dragImage(event) {
      if (!this.dragging) return;
      const dx = event.clientX - this.startX;
      const dy = event.clientY - this.startY;
      this.imageStyle.left = `${this.initialLeft + dx}px`;
      this.imageStyle.top = `${this.initialTop + dy}px`;
    },
    stopDrag() {
      this.dragging = false;
    },
    zoomImage(event) {
      event.preventDefault();
      if (event.deltaY < 0) {
        this.zoom *= 1.1;
      } else {
        this.zoom /= 1.1;
      }
      this.imageStyle.transform = `scale(${this.zoom})`;
    },
  },
};
</script>

<style lang="scss" scoped>
.view-close {
  font-size: 50px;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    color: red;
  }
}

.thumbnail {
  width: 150px;
  cursor: pointer;
  transition: transform 0.3s;
}

.thumbnail:hover {
  transform: scale(1.05);
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.image-container {
  position: relative;
  cursor: move;
}

.full-image {
  max-width: inherit;
  max-height: inherit;
  position: relative;
  transition: transform 0.3s;
}
</style>
